import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ className = "", label = "Indietro" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  const go = () => (window.history.length > 1 && window.history.state?.idx > 0 ? navigate(-1) : navigate("/"));
  return (
    <button type="button" onClick={go} aria-label="Torna indietro" data-testid="back-btn"
      className={`inline-flex items-center gap-1 h-9 px-3 rounded-full text-sm font-medium text-stone-600 hover:text-[#0F4C81] hover:bg-stone-100 transition-colors ${className}`}>
      <ArrowLeft className="w-4 h-4" /><span className="hidden sm:inline">{label}</span>
    </button>
  );
}
